const translations = {
  createAccount: 'CREATE ACCOUNT',
  oldUser: 'Already have an account?',
  login: 'Log in.',
  emailExists: 'User with this email already exists.',
};

export default translations;
